// src/themes/light.ts
import { Theme } from "./types";

export const lightTheme: Theme = {
  "background-light": "248 250 252", // Lighter background: #F8FAFC (was #F0F2F5)
  "background-dark": "240 242 245", // Original as dark variant
  "card-light": "255 255 255", // #FFFFFF
  "card-dark": "250 250 250", // Slightly off-white
  "input-light": "243 246 249", // Lighter input: #F3F6F9 (was #E9EEF3)
  "input-dark": "238 242 247", // Darker variant
  "border-light": "226 232 240", // Softer border: #E2E8F0 (was #DCE4ED)
  "border-dark": "203 213 225", // #CBD5E1
  primary: "99 102 241", // #6366F1
  "primary-hover": "79 70 229", // #4F46E5
  text: "15 23 42", // Darker text: #0F172A (was #1F2937)
  "text-dark": "30 41 59", // #1E293B
  "text-secondary": "71 85 105", // Better contrast: #475569 (was #6B7280)
  "text-secondary-dark": "100 116 139", // #64748B
};
